export default {
  default: () => import("/vercel/path0/src/layouts/default.vue").then(m => m.default || m)
}